// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Label = require("../common/Components/Label.bs.js");
var DateIcon = require("../common/Components/DateIcon.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var ReactRender = require("../../reason/utils/ReactRender.bs.js");
var Core__Option = require("@rescript/core/src/Core__Option.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyPageShowingsList_showing_graphql = require("../../__generated__/PropertyPageShowingsList_showing_graphql.bs.js");
var PropertyPageShowingsList_showings_graphql = require("../../__generated__/PropertyPageShowingsList_showings_graphql.bs.js");

var convertFragment = PropertyPageShowingsList_showing_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageShowingsList_showing_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageShowingsList_showing_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyPageShowingsList_showing_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageShowingsList_showing_graphql.node, convertFragment, fRef);
}

var ShowingFragment_showingTypeV5_decode = PropertyPageShowingsList_showing_graphql.Utils.showingTypeV5_decode;

var ShowingFragment_showingTypeV5_fromString = PropertyPageShowingsList_showing_graphql.Utils.showingTypeV5_fromString;

var ShowingFragment = {
  showingTypeV5_decode: ShowingFragment_showingTypeV5_decode,
  showingTypeV5_fromString: ShowingFragment_showingTypeV5_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyPage__ShowingsList$Card(props) {
  var showing = use(props.showing);
  var date = showing.startDateV2.toLocaleString("en-us", {
        weekday: "short",
        month: "short",
        day: "numeric"
      });
  var startTime = showing.startDateV2.toLocaleString("en-us", {
        hour: "numeric",
        minute: "numeric"
      });
  var endTime = showing.endDateV2.toLocaleString("en-us", {
        hour: "numeric",
        minute: "numeric"
      });
  var match = showing.type_;
  var badgeText;
  if (match === "BUYERS_WELCOME" || match === "AGENTS_ONLY" || match === "TAN_ONLY") {
    switch (match) {
      case "AGENTS_ONLY" :
          badgeText = "Agents only";
          break;
      case "BUYERS_WELCOME" :
          badgeText = "Buyers welcome";
          break;
      case "TAN_ONLY" :
          badgeText = "TAN only";
          break;
      
    }
  } else {
    badgeText = undefined;
  }
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("div", {
                              children: JsxRuntime.jsx(DateIcon.FromPlainDate.make, {
                                    date: showing.startDateV2.toPlainDate()
                                  }),
                              className: ""
                            }),
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: date,
                                      className: "text-lg font-medium text-gray-800"
                                    }),
                                JsxRuntime.jsx("div", {
                                      children: startTime + " - " + endTime,
                                      className: "text-lg"
                                    })
                              ],
                              className: "flex-1 flex flex-col justify-between gap-1.5"
                            }),
                        badgeText !== undefined ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(Label.Neutral.make, {
                                      text: badgeText
                                    })
                              }) : null
                      ],
                      className: "flex flex-row space-x-4 relative"
                    }),
                (function (__x) {
                      return ReactRender.ifTrue(JsxRuntime.jsx("div", {
                                      children: Core__Option.getOr(showing.notes, ""),
                                      className: "mt-4 text-gray-500"
                                    }), __x);
                    })(props.shouldShowPropertyDetails)
              ],
              className: "bg-white border border-gray-200 rounded-md p-3"
            });
}

var Card = {
  ShowingFragment: ShowingFragment,
  make: PropertyPage__ShowingsList$Card
};

var convertFragment$1 = PropertyPageShowingsList_showings_graphql.Internal.convertFragment;

function waitForFragmentData$1(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyPageShowingsList_showings_graphql.node, convertFragment$1, fRef);
}

function use$1(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyPageShowingsList_showings_graphql.node, convertFragment$1, fRef);
}

function useOpt$1(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(fRef) : undefined, PropertyPageShowingsList_showings_graphql.node, convertFragment$1);
}

function readResolverFragment$1(fRef) {
  return RescriptRelay_Fragment.read(PropertyPageShowingsList_showings_graphql.node, convertFragment$1, fRef);
}

var ShowingsFragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment$1,
  waitForFragmentData: waitForFragmentData$1,
  use: use$1,
  useOpt: useOpt$1,
  readResolverFragment: readResolverFragment$1
};

function PropertyPage__ShowingsList(props) {
  var shouldShowPropertyDetails = props.shouldShowPropertyDetails;
  var showings = use$1(props.showings);
  var match = showings.length;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("h2", {
                      children: "Showings",
                      className: "text-2xl font-medium text-gray-800"
                    }),
                JsxRuntime.jsx("div", {
                      children: match !== 0 ? showings.map(function (showing) {
                              return JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx(PropertyPage__ShowingsList$Card, {
                                                showing: showing.fragmentRefs,
                                                shouldShowPropertyDetails: shouldShowPropertyDetails
                                              }),
                                          className: "max-w-md md:max-w-none"
                                        }, showing.id);
                            }) : "There are no scheduled showings.",
                      className: "grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6 items-stretch my-4"
                    })
              ]
            });
}

var make = PropertyPage__ShowingsList;

exports.Card = Card;
exports.ShowingsFragment = ShowingsFragment;
exports.make = make;
/* Label Not a pure module */
